var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-form-group-checkbox-group",
    _vm._b(
      {
        attrs: {
          buttons: true,
          form: _vm.form,
          options: _vm.options,
          property: _vm.property,
        },
        on: { change: _vm.emitChange },
      },
      "csp-form-group-checkbox-group",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }